"use strict";

exports.__esModule = true;
exports.BarChartCell = void 0;
var _react = _interopRequireDefault(require("react"));
var _BarChart = require("./BarChart");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BarChartCell = exports.BarChartCell = function BarChartCell(_ref) {
  var colProps = _ref.colProps,
    label = _ref.label,
    rawValue = _ref.rawValue;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "62px",
      paddingRight: "3px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      textAlign: "right"
    }
  }, label), /*#__PURE__*/_react["default"].createElement(_BarChart.BarChart, {
    style: {
      flex: 1
    },
    hoverable: true,
    backgroundColor: colProps.barChartBackgroundColor,
    minValue: colProps.barChartMinValue,
    maxValue: colProps.barChartMaxValue,
    value: rawValue,
    labelValue: label
  }));
};